import { Link, LinkProps } from "@mui/material";
import { FC, Fragment } from "react";

type LinkWrapperProps = LinkProps & {
  onClick: LinkProps["onClick"];
  wrapWithLink: boolean;
  children: React.ReactNode;
};

const LinkWrapper: FC<LinkWrapperProps> = ({
  onClick,
  wrapWithLink,
  children,
  ...rest
}) => {
  return wrapWithLink ? (
    <Link
      underline="hover"
      style={{ cursor: "pointer" }}
      {...rest}
      onClick={onClick}
    >
      {children}
    </Link>
  ) : (
    <Fragment>{children}</Fragment>
  );
};

export default LinkWrapper;
